
      jQuery(document).ready(($) => {
        var optionqty =  $(document).find(".prod__option--button .variant-picker__option input:checked+label").attr('data_selval');
        $('.optionvalcont').text(optionqty);
        $('.defaultval span').text(optionqty);
        $('.quantity').on('click', '.plus', function(e) {
            var optionqty =  $(document).find(".prod__option--button .variant-picker__option input:checked+label").attr('data_selval');
            var totalqty = 0;
            let $input = $(this).prev('input.qty');
            let val = parseInt($input.val());
            $input.val( val+1 ).change();
          
              $('.flavorlist_data .qty').each( function() {
                 var this_val = $(this).val();
                 if(this_val != 0){
                   totalqty += parseFloat(this_val);
                 }
              });
              if(optionqty == totalqty){
                $('input.qtyplus.plus').each( function() {
                 $(this).prop('disabled', true);
                });
                $('.flavorlist_data .qty').each( function() {
                  var this_val_zero = $(this).val();
                   if(this_val_zero == 0){
                    $(this).closest('.flavor_list').css("pointer-events", "none");
                   }
                });
            }
          
        });
 
        $('.quantity').on('click', '.minus', function(e) {
            var optionqty =  $(document).find(".prod__option--button .variant-picker__option input:checked+label").attr('data_selval');
            var totalqty = 0;
            let $input = $(this).next('input.qty');
            var val = parseInt($input.val());
            if (val > 0) {
                $input.val( val-1 ).change();
            }
             $('.flavorlist_data .qty').each( function() {
                 var this_val = $(this).val();
                 if(this_val != 0){
                   totalqty += parseFloat(this_val);
                 }
              });
              if(optionqty == totalqty){
                $('input.qtyplus.plus').each( function() {
                $(this).prop('disabled', true);
               });
                $('.flavorlist_data .qty').each( function() {
                  var this_val_zero = $(this).val();
                   if(this_val_zero == 0){
                    $(this).closest('.flavor_list').css("pointer-events", "none");
                   }
                });
              }else{
                $('input.qtyplus.plus').each( function() {
                 $(this).prop('disabled', false);
               });
                 $('.flavorlist_data .qty').each( function() {
                  var this_val_zero = $(this).val();
                   if(this_val_zero == 0){
                    $(this).closest('.flavor_list').css("pointer-events", "unset");
                   }
                });
             }
        });
        
    });

    $(document).on("click",".variant-picker__option label.product-option-item.sf-po__option-button",function() {
        $("p.choose_option").css("display", "none");
        $(".flavorlist_data input[name='flavor_name']").each(function () {
          $(this).prop('checked', false);
        });
         $('.flavorlist_data .qty').each( function() {
            $(this).val(0);
         });
         $('.flavor_qty.quantity').each( function() {
            $(this).css("pointer-events", "none");
         });
         $('.flavor_list').each( function() {
            $(this).css("pointer-events", "unset");
         });
         $('input.qtyplus.plus').each( function() {
           $(this).prop('disabled', false);
         });
      var mycnt = $(this).attr('data_vallab');
      $('.flavorlist_data .panels').each(function(){
        var optncnt = $(this).attr('data_title');
        if(optncnt == mycnt){
          $(this).show();
        }else{
          $(this).hide();
        }
      });
    var isvalcnt = $(this).attr('data_selval');
      $('.optionvalcont').text(isvalcnt);
    });
  $(document).on("click",".floavor_name input[type=checkbox]",function() {
         var qty_check = $(this).closest('.flavor_list').find('.qty').val();
         if(this.checked){
          $(this).closest('.flavor_list').find('.qty').val(1);
           $(this).closest('.flavor_list').find('.flavor_qty.quantity').css("pointer-events", "unset");
         }else{
           $(this).closest('.flavor_list').find('.qty').val(0);
           $(this).closest('.flavor_list').find('.flavor_qty.quantity').css("pointer-events", "none");
         }
          var totalqty = 0;
          var optionqty =  $(document).find(".prod__option--button .variant-picker__option input:checked+label").attr('data_selval');
          $('.flavorlist_data .qty').each( function() {
             var this_val = $(this).val();
             if(this_val != 0){
               totalqty += parseFloat(this_val);
             }
          });
          if(optionqty == totalqty){
            $('input.qtyplus.plus').each( function() {
              $(this).prop('disabled', true);
            });
            $('.flavorlist_data .qty').each( function() {
              var this_val_zero = $(this).val();
               if(this_val_zero == 0){
                $(this).closest('.flavor_list').css("pointer-events", "none");
               }
            });
          }else{
                $('input.qtyplus.plus').each( function() {
                 $(this).prop('disabled', false);
               });
                 $('.flavorlist_data .qty').each( function() {
                  var this_val_zero = $(this).val();
                   if(this_val_zero == 0){
                    $(this).closest('.flavor_list').css("pointer-events", "unset");
                   }
                });
          }
    });
    $(document).on("click","#cus_addtocart",function() {
      var isgiftpro = $('.flavor_list input#flavor6:checked').length;
     if (isgiftpro == 0) {
       var option_value =  $(document).find(".prod__option--button .variant-picker__option input:checked+label").attr('data_selval');
       var variant_id = $(document).find("#formId").val();
       var varQty = $(document).find("quantity-input input.quantity-input__element").val();
       //var checkedlength = $(".flavorlist_data input[name='flavor_name']:checked").length;
        var checkedlength = 0;
        $(".flavorlist_data input[name='flavor_name']:checked").each(function (index) {
            var nameqty = $(this).closest('.flavor_list').find('.qty').val();
            checkedlength += parseInt(nameqty); 
        });
       var categories = '';
       if(option_value == checkedlength){
            $("p.choose_option").css("display", "none");
            $(".flavorlist_data input[name='flavor_name']:checked").each(function (index) {
                var nameqty = $(this).closest('.flavor_list').find('.qty').val();
                if(nameqty != 0){
                   var name = $(this).val();
                   var combine = name+' * '+nameqty+',';
                   categories += combine;
                }
            });
            var categories = categories.replace(/,\s*$/, "");
             var arrdata = {
                "id": variant_id,
                "quantity": varQty,
                "properties": {
                 "Flavors": categories
                }
             }
            jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: arrdata,
                dataType: "json",
                success: function() {
                    window.location.href = "/cart";
                }
            });
       }else{
          $("p.choose_option span").text(option_value);
          $("p.choose_option").css("display", "block");
       }
    } else {
     var option_value =  $(document).find(".prod__option--button .variant-picker__option input:checked+label").attr('data_selval');
       var variant_id = $(document).find("#formId").val();
       var varQty = $(document).find("quantity-input input.quantity-input__element").val();
       //var checkedlength = $(".flavorlist_data input[name='flavor_name']:checked").length;
        var checkedlength = 0;
        $(".flavorlist_data input[name='flavor_name']:checked").each(function (index) {
            var nameqty = $(this).closest('.flavor_list').find('.qty').val();
            checkedlength += parseInt(nameqty); 
        });
       var categories = '';
       if(option_value == checkedlength){
            $("p.choose_option").css("display", "none");
            $(".flavorlist_data input[name='flavor_name']:checked").each(function (index) {
                var nameqty = $(this).closest('.flavor_list').find('.qty').val();
                if(nameqty != 0){
                   var name = $(this).val();
                   var combine = name+' * '+nameqty+',';
                   categories += combine;
                }
            });
            var categories = categories.replace(/,\s*$/, "");
             var arrdata = {
                "id": variant_id,
                "quantity": varQty,
                "properties": {
                 "Flavors": categories
                }
             }
            jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: arrdata,
                dataType: "json",
                success: function() {
                     var data_extra = {
            id: 46721269989675,
            quantity: 1,
          };
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data_extra,
            success: function (extra) {
              window.location.href = "/cart";
            }
          });
                }
            });
       }else{
          $("p.choose_option span").text(option_value);
          $("p.choose_option").css("display", "block");
       }
    }
      
       
      
    });        
